export default "__VITE_ASSET__08904b49__"